import { reupload } from "../../../../texts/fill";
import { useNavigate } from "react-router-dom";
import "../../FileFunctions.css";

const ReUpload = () => {
    const navigate = useNavigate();

    const reUpload = () => {
        navigate("/fill");
    };

    return (
        <button type="button" className="btn btn-outline-primary btn-lg reupload-btn" onClick={reUpload}>
            <img src="back.png" className="reupload-icon" />
            {reupload}
        </button>
    );
};

export default ReUpload;
